import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Trophy, Medal, Crown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function Leaderboard({ mockId, currentEntryId }) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/sample-mocks/${mockId}/leaderboard?limit=10`)
      .then(res => setEntries(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [mockId, currentEntryId]);

  if (loading) return null;
  if (entries.length === 0) return null;

  const rankIcons = [
    <Crown className="w-4 h-4 text-amber-400" />,
    <Medal className="w-4 h-4 text-slate-400" />,
    <Medal className="w-4 h-4 text-amber-700" />,
  ];

  return (
    <Card className="rounded-2xl" data-testid="leaderboard">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <Trophy className="w-4.5 h-4.5 text-amber-500" />
          <h3 className="text-sm font-bold text-slate-800">Leaderboard</h3>
          <Badge variant="secondary" className="text-[10px]">{entries.length} entries</Badge>
        </div>
        <div className="space-y-2">
          {entries.map((e, i) => {
            const isMe = e.id === currentEntryId;
            return (
              <div key={e.id}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors ${
                  isMe ? "bg-[#e0482d]/5 border border-[#e0482d]/20" : i % 2 === 0 ? "bg-slate-50" : ""
                }`} data-testid={`leaderboard-entry-${i}`}>
                <span className="w-6 text-center shrink-0">
                  {i < 3 ? rankIcons[i] : <span className="text-xs font-bold text-slate-400">{i + 1}</span>}
                </span>
                <span className={`text-sm font-medium flex-1 truncate ${isMe ? "text-[#e0482d]" : "text-slate-700"}`}>
                  {e.player_name} {isMe && <span className="text-[10px] text-[#e0482d]/60">(you)</span>}
                </span>
                <span className={`text-sm font-bold ${e.percentage >= 80 ? "text-emerald-600" : e.percentage >= 60 ? "text-blue-600" : "text-slate-600"}`}>
                  {e.percentage}%
                </span>
                {e.time_taken_seconds > 0 && (
                  <span className="text-[10px] text-slate-400 w-10 text-right">
                    {Math.floor(e.time_taken_seconds / 60)}:{(e.time_taken_seconds % 60).toString().padStart(2, "0")}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
